// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class PharmacyCardFinderAddress {
    static getAttributeTypeMap() {
        return PharmacyCardFinderAddress.attributeTypeMap;
    }
}
PharmacyCardFinderAddress.discriminator = undefined;
PharmacyCardFinderAddress.additionalProperties = false;
PharmacyCardFinderAddress.attributeTypeMap = [
    {
        "name": "address1",
        "baseName": "address1",
        "type": "string"
    },
    {
        "name": "address2",
        "baseName": "address2",
        "type": "string"
    },
    {
        "name": "city",
        "baseName": "city",
        "type": "string"
    },
    {
        "name": "state",
        "baseName": "state",
        "type": "string"
    },
    {
        "name": "zipCode",
        "baseName": "zipCode",
        "type": "string"
    },
];
//# sourceMappingURL=pharmacyCardFinderAddress.js.map